import React, { PropsWithChildren, useMemo } from "react";

import { AgentAPI } from "@/api";
import Query from "@/models/query";
import { ConfiguredByParentProvider } from "@/ui/_common_/configured-by-parent-alert";

type Props = PropsWithChildren<{
  agentId: number;
}>;

const WrapperTab = ({ agentId, children }: Props) => {
  const agentQuery = useMemo(() => {
    const query = new Query(async () => {
      return await AgentAPI.getById({ id: agentId });
    });
    query.submit({});
    return query;
  }, [agentId]);

  return (
    <ConfiguredByParentProvider
      value={agentQuery.data?.configuredByParent ?? false}
    >
      {children}
    </ConfiguredByParentProvider>
  );
};

export default WrapperTab;
